import { GOOGLE_SCRIPTS_WEBHOOK_URL, ENV } from '../core/constants';

export interface PurchaseEventLog {
  transactionId: string;
  price: number;
  currency: string;
  plan: string;
  eventId: string;
}

export const logPurchaseEvent = (data: PurchaseEventLog): void => {
  if (!GOOGLE_SCRIPTS_WEBHOOK_URL) return;

  const payload = {
    ...data,
    env: ENV,
    timestamp: new Date().toISOString(),
  };

  fetch(GOOGLE_SCRIPTS_WEBHOOK_URL, {
    method: 'POST',
    mode: 'no-cors',
    body: JSON.stringify(payload),
  }).catch(() => undefined);
};
